"use strict";

import React, {useEffect, useState} from 'react';
import dateFormat from "dateformat";
import Icon from "../../component/Icon";

const AccountEcheckListItem = ({echeck={},onRevokeEcheck=()=>{},}) => {
    const [confirmRevokeEcheck, setConfirmRevokeEcheck] = useState(false);

    const rowClassName = `echeck__echeck-table__row--${ echeck.state === 'AUTHORIZED' ? 'authorized' : 'revoked' }`;
    const columnClassName = `echeck__echeck-table__column--${ echeck.state === 'AUTHORIZED' ? 'authorized' : 'revoked' }`;
    const dateCreated = !!echeck.date_created ? new Date(echeck.date_created) : null;

    useEffect(()=>{
        setConfirmRevokeEcheck(()=>{
            return false;
        })
    },[echeck]);

    function onRevokeEcheckClick(e){
        e.preventDefault();
        setConfirmRevokeEcheck(()=>{
            return true;
        })
    }

    function onConfirmRevokeEcheckClick(e, revoke=false){
        e.preventDefault();
        if(revoke)
            onRevokeEcheck(echeck);
        else{
            setConfirmRevokeEcheck(()=>{
                return false;
            })
        }
    }

    if(confirmRevokeEcheck){
        return (
            <tr className="echeck__echeck__row--confirm-revoke">
                <td>
                    <div style={{opacity: '.3'}}
                       className="btn__alert btn--small">
                        <Icon name="trash" />
                    </div>
                </td>
                <td colSpan="5">
                    <div style={{padding: '1rem',}}>
                        <strong>Confirm:</strong> Are you sure? <a href="#"
                           className="btn__secondary--outline btn--small"
                           onClick={(e)=>{onConfirmRevokeEcheckClick(e, false)}}>
                            Cancel
                        </a> <a href="#"
                           className="btn__alert btn--small"
                           onClick={(e)=>{onConfirmRevokeEcheckClick(e, true)}}>
                            Revoke
                        </a>
                    </div>
                </td>
            </tr>
        );
    }
    else{
        return (
            <tr className={rowClassName}>
                <td className={columnClassName}>
                    { !!echeck.state && echeck.state === 'AUTHORIZED' &&
                    <a href="#"
                       className="btn__alert btn--small"
                       onClick={onRevokeEcheckClick}
                       title="Revoke This Authorization">
                        <Icon name="trash" />
                    </a>
                    }
                </td>
                <td className={columnClassName}>{echeck.account_type}</td>
                <td className={columnClassName}>{echeck.account_nick_name}</td>
                <td className={columnClassName}>{echeck.bank_name}</td>
                <td className={columnClassName}>{echeck.state}</td>
                <td className={columnClassName}>{!!dateCreated && dateFormat(dateCreated, 'GMT:mm/dd/yy')}</td>
            </tr>
        );
    }
};

export default AccountEcheckListItem;
